import * as queryKeys from "@/data/constant/queryKeys";
import { request } from "@/util/api";
import { useQuery } from "@tanstack/react-query";

const useCargoOwnerData = (search?: any, enabled?: boolean) => {
  return useQuery<any[]>({
    queryKey: [queryKeys.CARGO_OWNER_DATA, search],
    queryFn: () =>
      request({
        method: "GET",
        url: `/companyManage/lookup/isCargoOwner`,
        params: search,
      }),
    enabled: enabled,
  });
};

export default useCargoOwnerData;
